// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3866":"css/admin-app.6847","5683":"css/app.6847"}[chunkId] + ".css";
};